<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull || !isLive"
      @refresh="onRefresh"
    >
      <!-- 未开始-0 或 已结束-2  -->
      <div
        v-if="!isLive"
        class="pageNative flex_center"
      >
        <!-- <img
          v-if="isNotOpen"
          :src="`${CDN_URL_1}/box_subscribe/unStart.png`"
        /> -->
        <div v-if="isNotOpen && hasFetched" class="nativeStatus">
          活动将于 {{ activityInfo.startTime }} 开始
        </div>
        <!-- <img
          v-if="isPassed"
          :src="`${CDN_URL_1}/box_subscribe/end.png`"
        /> -->
        <div v-if="isPassed && hasFetched" class="nativeStatus">
          活动已结束
        </div>
      </div>
      <div
        v-else
        class="page"
      >
        <div class="lucky_header">
          <img :src="activityInfo.icon" alt="">
          <div class="rule fs_12 flex_center" @click="handleGoRulePage">活动规则</div>
          <GameSelect
            class="lucky_game"
            :gameList="gameList"
            :activeGameId="activeGameId"
            @changeActiveGame="handleChangeActiveGame"
          />
        </div>
        <div class="lucky">
          <div class="lucky_record" @click="handleGoRecordPage">查看中奖记录 ></div>
          <div class="lucky_news">
            <van-notice-bar
              left-icon="volume-o"
              :scrollable="false"
              background="transparent"
            >
              <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="3000"
                :show-indicators="false"
              >
                <van-swipe-item
                  v-for="(item, idx) in fakeNews"
                  :key="idx"
                >{{ item }}</van-swipe-item>
              </van-swipe>
            </van-notice-bar>
          </div>
          <div
            class="lucky_main bg_contain"
            :style="{
              backgroundImage: `url(${rootCDNUrl}/draw.png)`
            }"
          >
            <div class="lucky_wrap">
              <div class="lucky_content" @click="handleContainerClick">
                <LuckyGrid
                  ref="luckyGrid"
                  width="4.1067rem"
                  height="3.6533rem"
                  :rows="3"
                  :cols="3"
                  :prizes="prizes"
                  v-bind="extraAttrs"
                  @start="onluckyStart"
                  @end="onluckyEnd"
                />
              </div>
              <div
                class="lucky_center bg_fullsize flex_center"
                style="flex-direction: column;"
                :style="{
                  backgroundImage: `url(${rootCDNUrl}/game_icon_wrap.png)`
                }"
              >
                <div
                  class="lucky_game_icon bg_contain"
                  :style="{
                    backgroundImage: `url(${curGameInfo.gameIcon})`
                  }"
                ></div>
                <div class="lucky_game_name fs_12 scale08_center van-ellipsis">{{ curGameInfo.gameName }}</div>
              </div>
            </div>
            <div
              class="lucky_drawtext bg_fullsize pos_x_center"
              :style="{
                backgroundImage: `url(${require('./assets/draw_text.png')})`
              }"
            >
              <p>{{ curLotteryInfo.remark }}</p>
            </div>
            <div
              class="lucky_btn bg_contain"
              :style="{
                backgroundImage: `url(${rootCDNUrl}/btn.png)`
              }"
              @click="onStartLottery"
            >
              <div class="lucky_btn_rest pos_x_center fs_12 scale09_center">
                抽奖次数剩余 <span style="color: #FF1515; font-weight: bold;">{{ curLotteryInfo.remind }}</span> 次
              </div>
            </div>
          </div>
        </div>
        <div
          class="chances bg_fullsize"
          :style="{
            backgroundImage: `url(${rootCDNUrl}/chance_bg.png)`
          }"
        >
          <div class="chance_item" v-if="curLotteryInfo.regReward !== 2">
            <div class="chance_item_main">
              <div class="chance_item_title">下载盒子包注册创角</div>
              <div class="chance_item_count">抽奖机会 +{{ curLotteryInfo.regRewardNum }}</div>
            </div>
            <div
              class="chance_item_btn bg_fullsize flex_center fs_12"
              :class="{
                filter_grayscale: hasRole
              }"
              :style="{
                backgroundImage: `url(${rootCDNUrl}/receive.png)`
              }"
              @click="handleReceive(1)"
            >{{ hasRole ? '已' : '' }}领取</div>
          </div>
          <div class="chance_item">
            <div class="chance_item_main">
              <div class="chance_item_title">每笔付费满{{ curLotteryInfo.payValue }}元</div>
              <div class="chance_item_count">抽奖机会 +{{ curLotteryInfo.num }}</div>
            </div>
            <div
              class="chance_item_btn bg_fullsize flex_center fs_12"
              :style="{
                backgroundImage: `url(${rootCDNUrl}/receive.png)`
              }"
              @click="handleReceive(2)"
            >领取</div>
          </div>
        </div>
        <div class="tips fs_14 mb_18 mt_14 text_center" style="color: #FFED87">
          <p class="mb_12">温馨提示：</p>
          <p>该活动创角奖励与盒子内其余活动创角奖励不共享</p>
        </div>
      </div>
    </PullRefresh>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      :headerStyle="{
        background: '#8a18e7'
      }"
      confirmButtonColor="#8a18e7"
      :innerTitleStyle="{color: '#8a18e7'}"
      @confirm="feedback.onSure"
    >
      <template v-if="feedbackType === 3">
        <div>
          <div class="mb_12" style="text-align: center;">
            单笔付费金额未满
            <span style="color: #ff7352">{{ curLotteryInfo.payValue }}</span>
            元
          </div>
          <div style="white-space: pre-line; font-size: 14px; line-height: 1.35; color: #333;">
            {{ curLotteryInfo.payRemark }}
          </div>
        </div>
      </template>
      <div v-if="feedbackType === 4">
        <div class="pos mb_12 flex_center" style="flex-direction: column;">
          <div
            class="pos_img mb_4 bg_contain"
            :style="{
              backgroundImage: `url(${curLotteryPosition.prizeIcon})`
            }"
          >
          </div>
          <div class="pos_name mb_6">{{ curLotteryPosition.prizeName }}</div>
          <div class="pos_desc fs_12">礼包内容：{{ curLotteryPosition.giftDesc }}</div>
        </div>
        <p>礼包码已存放在</p>
        <p>【我的】-【我的礼包】-【活动礼包】</p>
      </div>
      <div v-if="feedbackType === 6">
        <div class="flex_center mb_12">
          <img style="width: 0.72rem;" :src="curSelectPrizeInfo.prizeIcon" />
        </div>
      </div>
      <!-- 推荐游戏 -->
      <div v-if="feedbackType === 8">
        <div
          v-for="it in recGames"
          :key="it.gameId"
          class="game_item flex_center border_bottom_1px mb_8"
        >
          <div
            class="game_icon mr_6 bg_contain"
            :style="{ backgroundImage: `url(${it.logo})` }"
          ></div>
          <div class="game_main flex_1" style="width: 0;">
            <div class="game_top mb_2 flex_between">
              <div class="game_info flex_1" style="width: 0;">
                <div class="game_title mb_6 fs_15 color_black van-ellipsis">{{ it.gameName }}</div>
                <!-- <div class="game_desc d_flex">
                  <div class="game_score color_grey pr_6 mr_6">{{ it.score }}分</div>
                  <div class="game_version color_grey pr_6 mr_6">{{ it.version }}版本</div>
                  <div v-if="it.depict" class="game_depict color_grey pr_6 mr_6">{{ it.depict }}</div>
                </div> -->
              </div>
              <div class="game_btn" :class="{ game_btn_disabled: it.roleStatus !== 1 }"  @click.stop="onGoDownload(it)">
                {{ it.roleStatus === 1 ? '去下载' : '已有角色' }}
              </div>
            </div>
            <GameTag :tags="it.tagV2s" />
            <!-- 额外等级条件 -->
            <div v-if="curLotteryInfo.roleLimitStatus === 1 && curLotteryInfo.roleLimit !== undefined" class="game_extra_condition color_black mt_4 fs_11">
              角色等级达{{ it.roleLimit }}级后可领取
            </div>
          </div>
        </div>
      </div>
    </ActivityPopup>
  </div>
</template>

<script>
import {
  setPageTitle,
  toLogin,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  loginSuccess,
} from "@/bridge/AppJsBridge";
import { PullRefresh, NoticeBar, Swipe, SwipeItem } from "vant";
import { CDN_URL_1 } from "@/config";
import EventTrack from '@/mixins/eventTrack'
import GameSelect from './gameSelect.vue'
import {
  getDrawLotteryActApi, getDrawLotteryGamesV2Api,
  getDrawLotteryGameInfoApi, drawLotteryReceiveApi,
  drawLotteryDrawApi, getRecGamesApi, reportDownloadRecApi,
} from '@/apis/wxActivity'
import ActivityPopup from '@/components/btBox/ActivityPopup.vue';
import GameTag from '@/views/box/rebate2voucher/gameTag.vue'
export default {
  components: {
    GameSelect,
    PullRefresh,
    ActivityPopup,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    GameTag,
  },
  mixins: [EventTrack],
  data () {
    return {
      rootCDNUrl: 'https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_wxDrawLottery',
      CDN_URL_1,
      activityInfo: {
        id: ' ',
        startTime: "2022-01-01",
        title: "",
        icon: "",
        endTime: "2022-01-02",
      },
      hasFetched: false,
      activeGameId: '',
      gameList: [],
      isLoading: false,
      disabledPull: false, // 禁用下拉刷新
      curLotteryId: '', // 当前中奖的 id
      curLotteryInfo: {}, // 当前选中游戏会场的抽奖信息
      curSelectPrizeInfo: {}, // 当前选中的奖品信息
      prizes: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 2 },
        { x: 0, y: 2 },
        { x: 0, y: 1 },
      ],
      extraAttrs: {
        defaultStyle: {
          background: 'transparent',
          fontSize: '14px',
          fontColor: '#fff',
        },
        activeStyle: {
          background: 'transparent'
        },
        blocks: [
          { padding: '10px', background: 'transparent' },
        ],
      },
      lotteryLoading: false, // 抽奖的 loading， 预防多次触发
      visible: false,
      feedbackType: 0,
      recGames: [],
      goLoading: false,
    }
  },
  computed: {
    isWx () {
      // platform 0: wx 1: bt
      return this.$route.query.platform * 1 !== 1
    },
    activityId () {
      return this.$route.query.id || this.activityInfo.id
    },
    isLive () {
      if (!this.activityInfo.id && this.hasFetched) return false
      return !this.isPassed && !this.isNotOpen
    },
    isPassed () {
      const { endTime } = this.activityInfo
      const THIS_MOMENT = Date.now()
      return new Date(endTime).getTime() < THIS_MOMENT
    },
    isNotOpen () {
      const { startTime } = this.activityInfo
      const THIS_MOMENT = Date.now()
      return new Date(startTime).getTime() > THIS_MOMENT
    },
    curGameInfo () {
      return this.gameList.find(it => it.gameId === this.activeGameId) || {}
    },
    theTop4Games () {
      const gList = this.gameList
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 4
      const currentIdx = gList.findIndex(it => it.gameId === this.activeGameId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.gameId === this.activeGameId) return
        res.push(it)
      })
      return res
    },
    hasRole () {
      return [2, 3].includes(this.curLotteryInfo.register)
    },
    // 假广播
    fakeNews () {
      const { record = [] } = this.curLotteryInfo
      return record || []
    },
    // 中奖版位信息
    curLotteryPosition () {
      const { positionList = [] } = this.curLotteryInfo
      if (!this.curLotteryId) return {}
      return positionList.find(it => it.position === this.curLotteryId)
    },
    // 这里的键名对应 popup 的 props
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      const { roleLimit, roleLimitStatus, regRewardNum, roleRewardShowGame } = this.curLotteryInfo
      return [
        {
          title: '领取抽奖机会',
          message: [
            `检测到活动期间您在《${roleRewardShowGame || this.curGameInfo.gameName}》`,
            `中已创角成功，送您${regRewardNum}次抽奖机会`
          ],
          confirmButtonText: '我知道了',
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `您在《${this.curGameInfo.gameName}》中已有历史创角，`,
            '去其他游戏会场看看吧~'
          ],
          confirmButtonText: '我知道了',
          onSure: () => {
            this.triggerVisible(false)
            this.eventTrack({
              event: 'register_lottery_button',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                type: 2
              })
            })
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `未检测到创角记录，下载《${this.curGameInfo.gameName}》`,
            '创角后即可领取抽奖机会'
          ],
          confirmButtonText: '下载游戏',
          onSure: () => {
            this.eventTrack({
              event: 'register_lottery_button',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                type: 2
              })
            })
            this.triggerVisible(false)
            this.handleGoGameDetail()
          }
        },
        {
          title: '不满足领取条件',
          message: [],
          confirmButtonText: '去完成',
          onSure: () => {
            this.eventTrack({
              event: 'register_lottery_button',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                type: 3
              })
            })
            this.triggerVisible(false)
            this.handleGoGameDetail()
          }
        },
        {
          title: '中奖结果',
          message: [],
          confirmButtonText: '查看礼包码',
          onSure: () => {
            const { objId, prizeName } = this.curLotteryPosition
            this.eventTrack({
              event: 'register_lottery_result_button',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                gift_id: objId,
                prize_name: prizeName,
                type: 1,
              })
            })
            const data = {
              routePath: "/gift/MineGiftActivity",
              extraParams: 3, // 2 -> BT盒子活动 3-> 玩心盒子活动
            };
            const dataStr = JSON.stringify(data);
            jumpToNative(dataStr)
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: ['兑换码生成错误，请联系客服领取备用码！'],
          confirmButtonText: '联系客服',
          onSure: () => {
            const { objId, prizeName } = this.curLotteryPosition
            this.eventTrack({
              event: 'register_lottery_result_button',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                gift_id: objId,
                prize_name: prizeName,
                type: 2,
              })
            })
            this.triggerVisible(false)
            this.$router.push({
              name: `box.customerService`,
            });
          }
        },
        {
          title: this.curSelectPrizeInfo.prizeName,
          message: [this.curSelectPrizeInfo.giftDesc],
          confirmButtonText: '去抽奖',
          onSure: () => {
            // const { objId, prizeName } = this.curLotteryPosition
            // this.eventTrack({
            //   event: 'register_lottery_result_button',
            //   event_field: JSON.stringify({
            //     ...this.commonTrackParams,
            //     gift_id: objId,
            //     prize_name: prizeName,
            //     type: 2,
            //   })
            // })
            this.triggerVisible(false)
          }
        },
        {
          title: '温馨提示',
          message: [
            '您不是该游戏用户，暂时无法参与'
          ],
          confirmButtonText: '知道了',
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '推荐游戏',
          innerTitle: `完成推荐游戏创角${roleLimitStatus === 1 ? '且等级达标后' : ''}领抽奖机会`,
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `当前账号不满足条件，请进入游戏`,
            `且等级达${roleLimit}级后即可领取抽奖机会`,
          ],
          confirmButtonText: '下载游戏',
          onSure: () => {
            this.triggerVisible(false)
            this.handleGoGameDetail()
          }
        },
      ]
    },
    commonTrackParams () {
      const { id } = this.activityInfo
      const { gameId, gameName, placeId } = this.curGameInfo
      return {
        activity_id: id,
        game_id: gameId,
        game_name: gameName,
        place_id: placeId,
      }
    },
  },
  mounted () {
    // 如果浏览器没有调用接口，可以加上 IS_DEV 的 query 参数
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  activated () {
    setPageTitle(this.activityInfo.title)
    if (!this.isLive) return
  },
  watch: {
    curGameInfo: {
      handler (val) {
        if (val.placeId) {
          this.getWelfareList()
        }
      },
      deep: true
    },
  },
  methods: {
    onRefresh () {
      this.init().then(res => {
        this.isLoading = false
      })
    },
    getActivityInfo () {
      this.init()
    },
    init () {
      return this.getActInfo().then(res => {
        setPageTitle(this.activityInfo.title)
        if (!this.isLive) return
        return this.getGames().then(res => {
          this.eventTrack({
            event: 'register_lottery_page',
            event_field: JSON.stringify({
              ...this.commonTrackParams
            })
          })
        })
      })
    },
    // 获取活动详情
    getActInfo () {
      return getDrawLotteryActApi({
        activityId: this.activityId,
      }, !this.isWx).then(res => {
        this.activityInfo = res.data || {
          id: '',
          startTime: "2022-01-01",
          title: "抽奖活动",
          icon: "",
          endTime: "2022-01-02",
        }
        this.hasFetched = true
      })
    },
    // 获取活动下游戏会场列表
    getGames () {
      return getDrawLotteryGamesV2Api({
        activityId: this.activityId,
        type: 1,
      }, !this.isWx).then(res => {
        const { locationPlaceId, placeVos } = res.data
        const it = placeVos.find(it => it.placeId === locationPlaceId)
        if (locationPlaceId && it) {
          this.handleChangeActiveGame(it)
        } else {
          if (placeVos.length) {
            this.handleChangeActiveGame(placeVos[0])
          }
        }
        this.gameList = placeVos
      }).catch((err) => {
        if (err.response && err.response.data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity")
        }
      })
    },
    getWelfareList (isRerenderCanvas = true) {
      return getDrawLotteryGameInfoApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId 
      }, !this.isWx).then(res => {
        this.curLotteryInfo = res.data || {}
        if (res.data.register === 2) {
          this.feedbackType = 0
          this.triggerVisible(true)

          this.eventTrack({
            event: 'register_lottery_popup',
            event_field: JSON.stringify({
              ...this.commonTrackParams
            })
          })
        }
        if (isRerenderCanvas) {
          const { positionList = [] } = this.curLotteryInfo
          this.prizes = this.prizes.map((it, idx) => {
            const curPosi = positionList[idx]
            if (!curPosi) return {}
            const { prizeIcon, prizeName } = curPosi
            it.imgs = [
              { src: `${this.rootCDNUrl}/lottery_default.png`, activeSrc: `${this.rootCDNUrl}/lottery_selected.png`, width: '112%', height: '112%' },
              { src: prizeIcon, width: '50%', top: '15%' },
            ]
            it.fonts = [{
              text: prizeName,
              top: '75%',
            }]
            return it
          })
          // 抽奖 canvas 重新渲染
          this.$refs.luckyGrid.init()
        }
      })
    },
    // 切换所选游戏
    handleChangeActiveGame (gm) {
      const { gameId, gameName, enterStatus, placeId } = gm
      this.activeGameId = gameId
      this.eventTrack({
        event: 'register_lottery_game',
        event_field: JSON.stringify({
          ...this.commonTrackParams
        })
      })
    },
    handleReceive (type) {
      if (type === 1 && this.hasRole) return
      this.eventTrack({
        event: 'register_lottery_get',
        event_field: JSON.stringify({
          ...this.commonTrackParams,
          type,
        })
      })
      drawLotteryReceiveApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId,
        type,
      }, !this.isWx).then(res => {
        const { num, payNum } = res.data
        const { payValue, num: numPerPay, regRewardNum } = this.curLotteryInfo
        // 获取抽奖次数
        if (num) {
          this.curLotteryInfo.remind = num
        }
        let msg = ''
        if (type === 1) {
          msg = '领取次数 +' + (regRewardNum || 1)
          if (!this.hasRole) {
            // 置灰领取按钮
            this.curLotteryInfo.register = 3
          }
        }
        if (type === 2) {
          msg = `满${payValue}元单笔订单数量为${payNum}，领取次数 +${payNum * numPerPay}`
        }
        this.$toast(msg)
      }).catch((err) => {
        const { code, msg } = err
        if (code === 93004) {
          this.feedbackType = 2
        }
        if (code === 93005) {
          this.feedbackType = 1
        }
        if (code === 93006) {
          this.feedbackType = 3
        }
        if (code === 93009) {
          this.feedbackType = 7
          this.eventTrack({
            event: 'register_lottery_draw_discontent_pop',
            event_field: JSON.stringify({
              ...this.commonTrackParams,
              type: 1,
            })
          })
        }
        if (code === 93010) {
          getRecGamesApi({
            activityId: this.activityId,
            placeId: this.curGameInfo.placeId,
          }, !this.isWx).then(res => {
            this.recGames = res.data || []
          })
          this.feedbackType = 8
          this.eventTrack({
            event: 'register_lottery_draw_discontent_pop',
            event_field: JSON.stringify({
              ...this.commonTrackParams,
              type: 2,
            })
          })
        }
        if (code === 93012) {
          this.feedbackType = 9
        }
        if (![93004, 93005, 93006, 93009, 93010, 93012].includes(code)) {
          this.$toast(msg || "领取失败，请稍后再试")
          return
        }
        if ([93004, 93005, 93006].includes(code)) {
          this.eventTrack({
            event: 'register_lottery_get_failed',
            event_field: JSON.stringify({
              ...this.commonTrackParams,
              type: this.feedbackType,
            })
          })
        }
        this.triggerVisible(true)
      })
    },
    onGoDownload (it) {
      if (it.roleStatus !== 1 || this.goLoading) return
      this.goLoading = true
      // 点击下载上报
      reportDownloadRecApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId,
        gameId: this.curGameInfo.gameId,
        recommendGameId: it.gameId,
      }, !this.isWx).then(res => {
        this.eventTrack({
          event: 'register_lottery_recommend_game_pop_button',
          event_field: JSON.stringify({
            ...this.commonTrackParams,
            recommend_game_id: it.gameId,
            recommend_game_name: it.gameName,
          })
        })
        this.handleGoGameDetail(it.gameId)
      }).finally(() => {
        this.goLoading = false
      })
    },
    onluckyStart () {
    },
    onluckyEnd () {},
    onStartLottery () {
      // if (1 == '1') return
      this.eventTrack({
        event: 'register_lottery_draw',
        event_field: JSON.stringify({
          ...this.commonTrackParams
        })
      })
      if (this.curLotteryInfo.remind <= 0) {
        this.$toast("没有抽奖机会了，请查看下方任务获取抽奖次数");
        return;
      }
      if (this.lotteryLoading) return
      console.log('start!!!')
      this.lotteryLoading = true
      drawLotteryDrawApi({
        activityId: this.activityId,
        placeId: this.curGameInfo.placeId,
      }, !this.isWx).then(res => {
        const { position, num, code } = res.data
        // 当前抽中的版位
        this.curLotteryId = position
        this.curLotteryInfo.remind = num
        this.$refs.luckyGrid.play()
        // accelerationTime[2500] + decelerationTime[2500] = 5000
        setTimeout(() => {
          const { positionList = [] } = this.curLotteryInfo
          const idx = positionList.findIndex(it => it.position === position)
          this.$refs.luckyGrid.stop(idx)
          console.log('over')
          setTimeout(() => {
            this.feedbackType = code ? 4 : 5
            this.triggerVisible(true)
            const { objId, prizeName } = positionList[idx] || {}
            this.eventTrack({
              event: 'register_lottery_result',
              event_field: JSON.stringify({
                ...this.commonTrackParams,
                gift_id: objId,
                prize_name: prizeName,
                type: code ? 1 : 2,
              })
            })
            this.lotteryLoading = false
            // 留 800ms 的滞空时间
          }, 5000 - 1000 + 800)
        }, 1000)
      }).catch((err) => {
        const { code } = err
        if (code === 93002) {
          this.curLotteryInfo.remind = 0
        }
        this.lotteryLoading = false
      })
    },
    handleContainerClick (event) {
      // 获取点击位置相对于父容器的坐标
      const { clientX, clientY } = event;
      const container = event.target;

      // 获取父容器的尺寸，包括 padding
      const containerRect = container.getBoundingClientRect();

      // 计算点击位置在父容器中的相对坐标
      const relativeX = clientX - containerRect.left;
      const relativeY = clientY - containerRect.top;

      // 计算父容器的内边距
      const paddingLeft = 6;
      const paddingTop = 8;

      // 计算点击的子 div 的行和列索引，考虑 padding
      const cellWidth = (containerRect.width - paddingLeft * 2) / 3;
      const cellHeight = (containerRect.height - paddingTop * 2) / 3;
      const rowIndex = Math.floor((relativeY - paddingTop) / cellHeight);
      const colIndex = Math.floor((relativeX - paddingLeft) / cellWidth);

      // 检查点击的子 div 是否在有效范围内
      if (
        rowIndex < 0 || rowIndex >= 3 ||
        colIndex < 0 || colIndex >= 3 ||
        (rowIndex === 1 && colIndex === 1)
      ) {
        return;
      }
      const indexMap = ['0-0', '0-1', '0-2', '1-2', '2-2', '2-1', '2-0', '1-0']
      const idx = indexMap.findIndex(it => it === `${rowIndex}-${colIndex}`)
      // 在这里处理点击事件
      // console.log(`Clicked on cell: Row ${rowIndex}, Col ${colIndex}, Number ${idx}`);
      this.handleShowRewardItem(idx)
    },
    handleShowRewardItem (idx) {
      const { positionList = [] } = this.curLotteryInfo
      this.curSelectPrizeInfo = positionList[idx] || {}
      const { objId, prizeName } = this.curSelectPrizeInfo
      this.feedbackType = 6
      this.triggerVisible(true)
      this.eventTrack({
        event: 'register_lottery_position_click',
        event_field: JSON.stringify({
          ...this.commonTrackParams,
          gift_id: objId,
          gift_name: prizeName,
        })
      })
    },
    triggerVisible (v) {
      this.visible = v
    },
    handleGoRulePage () {
      if (this.isWx) {
      this.$router.push({
        name: `box.actPlaceRule`,
        params: {
          type: 24,
        },
      });
      } else {
        this.$router.push({
          name: `box.btActRule`,
          params: {
            type: 14,
          },
        });
      }
    },
    handleGoRecordPage () {
      this.eventTrack({
        event: 'register_lottery_record',
        event_field: JSON.stringify({
          ...this.commonTrackParams
        })
      })

      this.$router.push({
        name: `box.drawLotteryRecord`,
        query: {
          id: this.activityId,
          gameId: this.activeGameId,
          platform: this.isWx ? 0 : 1,
        }
      })
    },

    handleGoGameDetail (gameId) {
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: this.isWx ? 40 : 35,
        extraParams: gameId || this.curGameInfo.gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
  },
}
</script>

<style lang="scss" scoped>
.pos {
  .pos_img {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }
  .pos_name {
    font-size: 16px;
    font-weight: bold;
  }
}
.pageNative {
  width: 100vw;
  height: 100vh;
  color: #fff;
  background: #44209c;
}
.container {
  background: #44209c;
}
.lucky_header {
  position: relative;
  img {
    width: 100%;
  }
  .lucky_game {
    position: absolute;
    bottom: 24px;
    margin-left: 18px;
  }
  .rule {
    position: absolute;
    right: 0;
    padding: 6px 10px 6px 16px;
    top: 12px;
    color: white;
    border: 1px solid #A8BBD4;
    border-top-left-radius: 1000px;
    border-bottom-left-radius: 1000px;
    background: #486FCF;
    transform: scale(0.85) translateX(1px);
    transform-origin: 100% 0%;
  }
}
.lucky_wrap {
  width: 100%;
  position: absolute;
  top: 54px;
  left: 4px;
  display: flex;
  justify-content: center;
}
.lucky_center {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 76px;
  height: 84px;
  padding: 4px 0 2px;
  transform: translate(-50%, calc(-50% + 4px));
  // z-index: 1;
  .lucky_game_icon {
    width: 68px;
    height: 70px;
    margin-bottom: 2px;
  }
  .lucky_game_name {
    width: 150%;
    text-align: center;
    white-space: nowrap;
    color: white;
  }
}
.lucky_drawtext {
  height: 48px;
  bottom: 126px;
  font-size: 14px;
  color: white;
  width: 298px;
  padding: 6px;
  line-height: 18px;
  text-align: center;
  white-space: pre-line;
  left: 183px;
}
.lucky_btn:active {
  transform: translateX(-50%) scaleY(0.93);
}
.lucky_btn {
  position: absolute;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  transform-origin: 50% 100%;
  transition: 0.1s all ease;
  display: inline-block;
  text-align: center;
  padding: 8px;
  width: 155px;
  height: 63px;
  .lucky_btn_rest {
    color: #4B4B4B;
    font-weight: bold;
    white-space: nowrap;
    position: absolute;
    bottom: 28px;
  }
}
// 中间抽奖部分
.lucky {
  position: relative;
  padding: 0 8px;
  .lucky_main {
    position: relative;
    padding: 6px;
    width: 100%;
    height: 507px; 
  }
}

.chances {
  color: white;
  margin: 12px 6px;
  padding: 32px 18px;
  .chance_item {
    display: flex;
    align-items: center;
    background: #4a2692;
    border-radius: 6px;
    padding: 14px 10px;
  }
  .chance_item + .chance_item {
    margin-top: 8px;
  }
  .chance_item_main {
    flex: 1;
  }
  .chance_item_btn {
    width: 87px;
    height: 29px;
  }
  .chance_item_title {
    font-size: 14px;
    margin-bottom: 12.5px;
  }
  .chance_item_count {
    font-size: 12.5px;
  }
}

.lucky_record {
  color: white;
  text-align: right;
  font-size: 12.5px;
  padding-right: 5px;
  margin-bottom: 2px;
}
.lucky_news {
  position: absolute;
  top: 27px;
  left: 18px;
  width: 300px;
  z-index: 1;
  ::v-deep(.van-notice-bar) {
    height: 32px;
  }
}
.notice-swipe {
  height: 26px;
  line-height: 26px;
}

.game_item {
  padding: 4px 4px;
  .game_icon {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    flex-shrink: 0;
  }
  .game_title {
    // white-space: nowrap;
  }
  .game_btn {
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 100px;
    color: #fff;
    background-color: #18BD30;
    flex-shrink: 0;
  }
  .game_btn_disabled {
    background-color: #ccc;
  }
}
</style>
